import * as angular from "angular";
import {IQService} from "angular";
import {PlanningAlertsService} from "./planning-alerts.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {PlanningTemplateDefaultDraftRequestsService} from "./planning-template-default-draft-requests.service";

export class PlanningTemplateDefaultDraftService {

  constructor(private planningTemplateDefaultDraftRequestsService: PlanningTemplateDefaultDraftRequestsService,
              private planningAlertsService: PlanningAlertsService, private $q: IQService, private bringozLoaderService: BringozLoaderService,
              private $log) {
  }

  getDefaultDraftTemplates(ids: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.planningTemplateDefaultDraftRequestsService.getDefaultDraftTemplates(ids)
      .then((createdProject) => {
        // this.planningAlertsService.createDefaultDraftTemplateSuccess();
        deferred.resolve(createdProject)
      })
      .catch((error) => {
        this.$log.error(error);
        // this.planningAlertsService.createDefaultDraftTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getDefaultDraftTemplate(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.planningTemplateDefaultDraftRequestsService.getDefaultDraftTemplate(id)
      .then((createdProject) => {
        // this.planningAlertsService.createDefaultDraftTemplateSuccess();
        deferred.resolve(createdProject)
      })
      .catch((error) => {
        this.$log.error(error);
        // this.planningAlertsService.createDefaultDraftTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createDefaultDraftTemplate(defaultDraftTemplate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.planningTemplateDefaultDraftRequestsService.createDefaultDraftTemplate(defaultDraftTemplate)
      .then((createdProject) => {
        this.planningAlertsService.createDefaultDraftTemplateSuccess();
        deferred.resolve(createdProject)
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.createDefaultDraftTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateDefaultDraftTemplate(defaultDraftTemplate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.planningTemplateDefaultDraftRequestsService.updateDefaultDraftTemplate(defaultDraftTemplate)
      .then((createdProject) => {
        this.planningAlertsService.updateDefaultDraftTemplateSuccess();
        deferred.resolve(createdProject)
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.updateDefaultDraftTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


}

angular
  .module('bringoz.admin.planning')
  .service('planningTemplateDefaultDraftService', PlanningTemplateDefaultDraftService);
